import React from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Text,
  Image,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";
import useAppNavigation from "../../Routes/useAppNavigation";

/**
 * PersonView - reusable read-only detail page for personnel.
 * `cards` is an array of { heading, rows: [{ label, value, full }] }.
 */
const Field = ({ label, value, full }) => (
  <View style={[styles.field, full && { width: "100%" }]}>
    <Text style={styles.fieldLabel}>{label}</Text>
    <Text style={styles.fieldValue}>{value}</Text>
  </View>
);

const PersonView = ({ title = "Details", name = "Mark Woods", cards = [] }) => {
  const navigation = useAppNavigation();
  return (
    <SafeAreaView style={styles.safe}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={AppImages.Backbtn} style={styles.backIcon} resizeMode="contain" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>{title}</Text>
      </View>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={styles.profileWrap}>
          <Image source={AppImages.profilePic} style={styles.profileImg} resizeMode="cover" />
          <Text style={styles.profileName}>{name}</Text>
        </View>
        {cards.map((card, i) => (
          <View key={i} style={styles.card}>
            <Text style={styles.cardHeading}>{card.heading}</Text>
            <View style={styles.grid}>
              {card.rows.map((r, j) => (
                <Field key={j} label={r.label} value={r.value} full={r.full} />
              ))}
            </View>
          </View>
        ))}
        <View style={{ height: 30 }} />
      </ScrollView>
    </SafeAreaView>
  );
};

export default PersonView;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },
  header: {
    width: "100%",
    height: 58,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 6,
  },
  backIcon: { width: 8, height: 15 },
  headerTitle: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
  },
  profileWrap: { alignItems: "center", marginTop: 24, marginBottom: 8 },
  profileImg: { width: 90, height: 90, borderRadius: 45, backgroundColor: AppColors.sandal },
  profileName: {
    marginTop: 12,
    color: AppColors.brown1,
    fontSize: 18,
    fontFamily: AppFonts.OverpassBold,
  },
  card: {
    backgroundColor: AppColors.white,
    borderWidth: 1,
    borderColor: "#9C49001A",
    borderRadius: 10,
    marginHorizontal: 20,
    marginTop: 16,
    padding: 16,
  },
  cardHeading: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassBold,
    marginBottom: 6,
  },
  grid: { flexDirection: "row", flexWrap: "wrap" },
  field: { width: "50%", marginTop: 14 },
  fieldLabel: {
    color: AppColors.dualbrown,
    fontSize: 12,
    fontFamily: AppFonts.OverpassRegular,
    marginBottom: 3,
  },
  fieldValue: { color: AppColors.brown1, fontSize: 14, fontFamily: AppFonts.OverpassSemiBold },
});
